export default Object.freeze({
  PREPAID: 'PREPAID',
});



// WEBPACK FOOTER //
// ./src/enums/modules/productEnum.js